import { Role, UserType } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { PermissionsConditionType } from '@/config/types';
import { useUserContext } from '@/contexts/UserContext/UserContext';

type usePermissionProps = {
  userTypes: UserType[];
  roles: Role[];
  conditionType: PermissionsConditionType;
};

export const usePermission = ({ userTypes, roles, conditionType }: usePermissionProps): boolean => {
  const { userEntity } = useUserContext();

  const [permission, setPermission] = useState(false);

  const meetsUserTypeCondition = (userTypes: UserType[]): boolean => {
    return userEntity?.hasUserType(userTypes) || false;
  };

  const meetsRoleCondition = (roles: Role[]): boolean => {
    return userEntity?.hasRole(roles) || false;
  };

  useEffect(() => {
    if (userEntity) {
      if (conditionType == PermissionsConditionType.AND) {
        setPermission(meetsUserTypeCondition(userTypes) && meetsRoleCondition(roles));
      }
      if (conditionType == PermissionsConditionType.OR) {
        setPermission(meetsUserTypeCondition(userTypes) || meetsRoleCondition(roles));
      }
    }
  }, [userEntity]);

  return permission;
};
